import endClientSession from './endClientSession';
import { getEntryPoint } from './getEntryPoint';

const logger = console.log;

export const loginEndSessionEntryPoint = ({ dispatch, getState }) => async (nextState, replace, callback) => {
  logger('hit login end session entry point');

  if (global.BROWSER) {
    const dynatraceScript = document.querySelector('script[src*="dynatrace"]');
    logger('dynatraceScript', dynatraceScript);
    endClientSession({ dispatch, getState });
    getEntryPoint();
    // maximum interval of 15 seconds
    let elapsed = 0;
    const intervalId = setInterval(() => {
      const isDynaTraceScriptLoaded = () => document.querySelector('script[src*="dynatrace"]');
      if (isDynaTraceScriptLoaded()) {
        logger('dynatrace consitional hit =', isDynaTraceScriptLoaded());
        window.dtrum.endSession();
        logger('dynatrace endSession called', window.dtrum);
        clearInterval(intervalId);
      }
      elapsed += 1000;
      if (elapsed >= 15000) {
        logger('time passed >= 15000 evaluated to true, =', elapsed);
        clearInterval(intervalId);
      }
    }, 1000);
  }
  callback();
};
